module.exports = __webpack_public_path__ + "assets/img/quiz_all_right.bb40e455.png";